module.exports = __webpack_public_path__ + "img/vk.921ba780.png";